import purchaseOrderRoutes from './purchaseOrderRoutes';
import salesOrderRoutes from './salesOrderRoutes';
import platformRoutes from './platformRoutes';


const supplyChainRoutes: any = [
  purchaseOrderRoutes,
  salesOrderRoutes,
  platformRoutes,
];

export default supplyChainRoutes;

